import { createPackageLogger, isDebugMode } from '@cloudbeds/frontend-logger';

export { isDebugMode };

/**
 * Simple custom log for given file name.
 * Only logs if __debug_mode is set in localStorage.
 * - Note: exception is log.error, which is always logged.
 *
 * Example usage:
 * ```
 * const logLocal = createLogLocal('PaymentElementWrapper.tsx');
 *
 * logLocal('onMount', 'Web component mounted');
 * // Output: [PEW] [PaymentElementWrapper.tsx] onMount :: Web component mounted
 *
 * logLocal('onMount', 'props:', props);
 * // Output: [PEW] [PaymentElementWrapper.tsx] onMount :: props: { ... }
 *
 * logLocal.error('onMount', 'Error occurred');
 * // Output: [PEW] [PaymentElementWrapper.tsx] onMount :: Error occurred
 * // Note: in this case, it's logged as an error message, and logs
 * // even if __debug_mode is not set.
 * ```
 */
export const createLogLocal = createPackageLogger('PEW', {
  pkgNameStyles:
    'background: darkslateblue; color: white; padding: 2px 3px 2px 3px; margin-left: 1px; border-radius: 3px;',
});
